var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isShow)?_c('router-view'):_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isShow),expression:"isShow",modifiers:{"fullscreen":true,"lock":true}}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }